import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Form } from 'antd';
import { Link } from 'react-router-dom';

import CallbackModal from 'components/CallbackModal';

import formAddBiller from '../../components/BillerForm/BillerForm.components';
import text from './BillerCreate.page.translation';
import './BillerCreate.style.less';
import billerRoute from '../../route';
const FormAddBillers = Form.create()(formAddBiller);
export default class BillerCreate extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalNotification: false,
      billerId: '',
      isSuccess: false,
      seriesResult: [],
    };
  }

  componentDidMount() {
    const defaultParam = 'page_num=1&page_size=50';
    this.props.getListService(defaultParam);
    this.props.getListForm(defaultParam);

    const getListBankParam = {
      page_num: 1,
      page_size: 150,
    };
    this.props.getListBank(getListBankParam);
    this.props.getListPaymentMethod();
  }

  onSubmitForm = (params, isSyncConsent) => {
    // will Submited When Everything is Valid
    this.props.billerCreate(params, isSyncConsent, this.billerCreateAction);
  };

  cancelSubmit = () => {
    const to = billerRoute.BILLERS;
    this.props.history.push(to);
  };

  billerCreateAction = (id, status, seriesResult) => {
    this.setState({
      modalNotification: true,
      isSuccess: status,
      billerId: id,
      seriesResult,
    });
  };

  _renderForm = () => {
    const { history, listPaymentMethod } = this.props;
    const biller = history.location.state || {};
    return (
      <FormAddBillers
        {...this.props}
        billerDetail={biller}
        listPaymentMethod={listPaymentMethod}
        onSubmit={this.onSubmitForm}
        cancelSubmit={this.cancelSubmit}
        formType="add"
      />
    );
  };

  goToBillerDetail = billerId => {
    const to = billerRoute.BILLERS_DETAIL.replace(':id', billerId);
    this.props.history.push(to);
  };

  onCloseModalNotification = () => {
    const { isSuccess, billerId } = this.state;
    if (isSuccess) {
      this.goToBillerDetail(billerId);
    } else {
      this.setState({
        modalNotification: false,
        isSuccess: false,
      });
    }
  };

  render() {
    const {
      intl: { formatMessage },
    } = this.props;

    const { modalNotification, seriesResult } = this.state;

    return (
      <div className="main-content add-biller">
        <div className="breadcrumb-wrapper">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/">Home</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={billerRoute.BILLERS}>
                {formatMessage(text.addBillerBreadcrumb)}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {formatMessage(text.addBillerBreadcrumb2)}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="white-box-wrapper">
          <div className="title-head">
            <span className="title">{formatMessage(text.addbiller)}</span>
          </div>

          <div className="inner-wrapper">{this._renderForm()}</div>
        </div>

        <CallbackModal
          modalVisible={modalNotification}
          onClose={this.onCloseModalNotification}
          btnText="Close"
          seriesResult={seriesResult}
        />
      </div>
    );
  }
}

BillerCreate.propTypes = {
  intl: PropTypes.object,
  billerCreate: PropTypes.func,
  listForm: PropTypes.array,
  listService: PropTypes.array,
  listBank: PropTypes.array,
  listTnc: PropTypes.array,
  getListForm: PropTypes.func,
  getListTnc: PropTypes.func,
  getListService: PropTypes.func,
  getListBank: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.object,
  }).isRequired,
  loading: PropTypes.bool,
  getListPaymentMethod: PropTypes.func,
  listPaymentMethod: PropTypes.array,
};
